export enum DocumentTypeLevel {
    Global = 0,
    QmAssociation = 1,
    Facility = 2,
    State = 3
}

// We only need this because we want QmAssociation => "Association".
export namespace DocumentTypeLevel {
    export function toString(): string;
    export function toString(level: DocumentTypeLevel): string;
    export function toString(level?: DocumentTypeLevel): string {
        return level !== null
            ? DocumentTypeLevel[level]?.replace('Qm', '')
            : Object.prototype.toString.call(DocumentTypeLevel);
    }

    export function toEnum(enumValue: string): DocumentTypeLevel {
        switch (enumValue) {
            case 'Association':
            case 'QmAssociation':
            case 'Qm Association':
                return DocumentTypeLevel.QmAssociation;
            case 'Facility':
                return DocumentTypeLevel.Facility;
            case 'State':
                return DocumentTypeLevel.State;
            default:
                return DocumentTypeLevel.Global;
        }
    }
}
